(function () {
  function isDesktop() {
    return window.matchMedia("(min-width: 769px)").matches;
  }

  function getSourcePanels(sidebar) {
    return Array.from(
      sidebar.querySelectorAll(".disclosure__panel[data-sidebar-panel-key]")
    ).filter((panel) => !panel.closest(".pc-real-product-list"));
  }

  function setActiveNavItems(items, activeIndex) {
    items.forEach((item, index) => {
      item.classList.toggle("active", index === activeIndex);
    });
  }

  function supportsSidebarBreadcrumb(sidebar) {
    return !!sidebar && !sidebar.classList.contains("sidebar-special");
  }

  function syncBreadcrumb(sidebar, sidebarItem, shouldShowBreadcrumb = false) {
    const breadcrumb = sidebar.querySelector("[data-sidebar-breadcrumb]");
    const breadcrumbLink = sidebar.querySelector("[data-sidebar-breadcrumb-link]");
    if (!breadcrumb || !breadcrumbLink) return;

    const title = sidebarItem?.dataset.sidebarTitle?.trim();
    const url = sidebarItem?.dataset.sidebarUrl?.trim();

    if (!shouldShowBreadcrumb || !title || !url) {
      breadcrumb.hidden = true;
      breadcrumbLink.textContent = "";
      breadcrumbLink.removeAttribute("href");
      return;
    }

    breadcrumb.hidden = false;
    breadcrumb.removeAttribute("hidden");
    breadcrumbLink.textContent = title;
    breadcrumbLink.href = url;
  }

  function cloneSidebarPanels(sidebar) {
    const productWrap = sidebar.querySelector(".pc-real-product-list");
    if (!productWrap) return [];

    productWrap.innerHTML = "";

    getSourcePanels(sidebar).forEach((panel) => {
      productWrap.appendChild(panel.cloneNode(true));
    });

    return Array.from(productWrap.querySelectorAll(".disclosure__panel"));
  }

  function findPanelByKey(panels, panelKey) {
    if (!panelKey) return null;
    return panels.find((panel) => panel.dataset.sidebarPanelKey === panelKey) || null;
  }

  function activateSidebarItem(
    sidebar,
    sidebarItem,
    activeChildIndex = 0,
    shouldShowBreadcrumb =
      supportsSidebarBreadcrumb(sidebar) && sidebar?.dataset.sidebarBreadcrumbVisible === "true"
  ) {
    if (!sidebar || !sidebarItem) return;

    const childNav = sidebarItem.closest(".child-nav");
    const trigger = sidebarItem.querySelector("[data-sidebar-trigger]");
    const panelKey = sidebarItem.dataset.sidebarPanelKey;
    const productWrap = sidebar.querySelector(".pc-real-product-list");

    if (childNav && trigger) {
      childNav.querySelectorAll(".is-visible").forEach((visibleItem) => {
        visibleItem.classList.remove("is-visible");
      });
      trigger.classList.add("is-visible");
    }

    const submenuItems = Array.from(sidebarItem.querySelectorAll(".nav-submenu .nav-item"));
    if (submenuItems.length) {
      const normalizedIndex = Math.min(activeChildIndex, submenuItems.length - 1);
      setActiveNavItems(submenuItems, normalizedIndex);
      activeChildIndex = normalizedIndex;
    } else {
      activeChildIndex = 0;
    }

    const sourcePanels = getSourcePanels(sidebar);
    let clonedPanels = Array.from(
      sidebar.querySelectorAll(".pc-real-product-list .disclosure__panel")
    );
    if (!clonedPanels.length) {
      clonedPanels = cloneSidebarPanels(sidebar);
    }
    const sourcePanel = findPanelByKey(sourcePanels, panelKey);
    let clonedPanel = findPanelByKey(clonedPanels, panelKey);
    if (!clonedPanel && clonedPanels.length) {
      clonedPanel = clonedPanels[0];
    }

    clonedPanels.forEach((panel) => {
      panel.classList.toggle("active", panel === clonedPanel);
    });

    [sourcePanel, clonedPanel].forEach((panel) => {
      if (!panel) return;
      const contentItems = Array.from(panel.querySelectorAll(".nav-item"));
      if (contentItems.length) {
        const normalizedIndex = Math.min(activeChildIndex, contentItems.length - 1);
        setActiveNavItems(contentItems, normalizedIndex);
      }
    });

    if (productWrap) {
      productWrap.scrollTop = 0;
    }

    sidebar.dataset.sidebarBreadcrumbVisible = shouldShowBreadcrumb ? "true" : "false";
    syncBreadcrumb(sidebar, sidebarItem, shouldShowBreadcrumb);
  }

  function bindNavToggleButtons(scope) {
    scope.querySelectorAll(".nav-item-action").forEach((btn) => {
      if (btn.dataset.navToggleBound === "true") return;
      btn.dataset.navToggleBound = "true";

      btn.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const navItem = btn.closest(".nav-item");
        const navItemList = navItem?.parentElement?.querySelectorAll(":scope > .nav-item");
        if (!navItem) return;

        const isActive = navItem.classList.contains("active");
        if (!navItemList || !navItemList.length) {
          navItem.classList.toggle("active", !isActive);
          return;
        }

        navItemList.forEach((item) => item.classList.remove("active"));
        if (!isActive) {
          navItem.classList.add("active");
        }
      });
    });
  }

  function initSidebar(sidebar) {
    if (!isDesktop()) return;
    if (!sidebar.querySelector(".pc-real-product-list")) return;

    cloneSidebarPanels(sidebar);
    bindNavToggleButtons(sidebar);

    if (sidebar.__headerNavClickHandler) {
      sidebar.removeEventListener("click", sidebar.__headerNavClickHandler);
    }

    sidebar.__headerNavClickHandler = function (event) {
      if (!isDesktop()) return;
      // Third-level items keep link navigation; panel sync is hover-based.
      if (event.target.closest(".nav-submenu .nav-item")) return;

      const trigger = event.target.closest("[data-sidebar-trigger]");
      if (!trigger || !sidebar.contains(trigger)) return;

      const sidebarItem = trigger.closest("[data-sidebar-item]");
      if (!sidebarItem || sidebarItem.dataset.sidebarHasPanel !== "true") return;

      const shouldShowBreadcrumb =
        supportsSidebarBreadcrumb(sidebar) && !!sidebarItem.querySelector(".nav-submenu .nav-item");
      event.preventDefault();
      event.stopPropagation();
      activateSidebarItem(sidebar, sidebarItem, 0, shouldShowBreadcrumb);
    };
    sidebar.addEventListener("click", sidebar.__headerNavClickHandler);

    if (sidebar.__headerNavHoverHandler) {
      sidebar.removeEventListener("mouseover", sidebar.__headerNavHoverHandler);
    }

    sidebar.__headerNavHoverHandler = function (event) {
      if (!isDesktop()) return;

      const navItem = event.target.closest(".nav-submenu .nav-item");
      if (!navItem || !sidebar.contains(navItem)) return;

      const sidebarItem = navItem.closest("[data-sidebar-item]");
      if (!sidebarItem) return;

      const siblings = Array.from(sidebarItem.querySelectorAll(".nav-submenu .nav-item"));
      const activeIndex = siblings.indexOf(navItem);
      if (activeIndex < 0 || navItem.classList.contains("active")) return;

      activateSidebarItem(sidebar, sidebarItem, activeIndex);
    };
    sidebar.addEventListener("mouseover", sidebar.__headerNavHoverHandler);

    const initialItem =
      sidebar.querySelector("[data-sidebar-item] [data-sidebar-trigger].is-visible")?.closest(
        "[data-sidebar-item]"
      ) ||
      sidebar.querySelector('[data-sidebar-item][data-sidebar-has-panel="true"]');

    if (initialItem) {
      const shouldShowBreadcrumb =
        supportsSidebarBreadcrumb(sidebar) && !!initialItem.querySelector(".nav-submenu .nav-item");
      sidebar.dataset.sidebarBreadcrumbVisible = shouldShowBreadcrumb ? "true" : "false";
      activateSidebarItem(sidebar, initialItem, 0, shouldShowBreadcrumb);
    } else {
      const clonedPanels = Array.from(
        sidebar.querySelectorAll(".pc-real-product-list .disclosure__panel")
      );
      if (clonedPanels.length) {
        clonedPanels.forEach((panel, index) => {
          panel.classList.toggle("active", index === 0);
        });
        const firstContentItems = Array.from(clonedPanels[0].querySelectorAll(".nav-item"));
        if (firstContentItems.length) {
          setActiveNavItems(firstContentItems, 0);
        }
      }
      sidebar.dataset.sidebarBreadcrumbVisible = "false";
      syncBreadcrumb(sidebar, null, false);
    }
  }

  function findSidebars(root) {
    const sidebars = [];
    if (root.matches?.(".mega-nav--sidebar")) {
      sidebars.push(root);
    }
    root.querySelectorAll?.(".mega-nav--sidebar").forEach((sidebar) => {
      sidebars.push(sidebar);
    });
    return sidebars;
  }

  function initHeaderSidebarNav(scope = document) {
    const root = scope && scope.querySelectorAll ? scope : document;
    bindNavToggleButtons(root);
    // Prefer .mega-nav--sidebar directly so MainMenu.open(details) still inits correctly.
    findSidebars(root).forEach(initSidebar);
  }

  window.initHeaderSidebarNav = initHeaderSidebarNav;

  function bootHeaderSidebarNav() {
    initHeaderSidebarNav(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootHeaderSidebarNav);
  } else {
    bootHeaderSidebarNav();
  }

  window.addEventListener("load", bootHeaderSidebarNav);

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initHeaderSidebarNav(document);
    }, 150);
  });
})();
